import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class StructureService {
  private baseUrl = environment.beServiceUrl;

  constructor(private http: HttpClient) {}

  getActors() {
    return this.http.get<{ id: number; code: string; name: string }[]>(this.baseUrl + '/v1/actor/find');
  }

  getStructureTypes() {
    return this.http.get<any>(this.baseUrl + '/v1/facility/types');
  }

  getStructuresFromType(typeId: string) {
    return this.http.get<any>(
      this.baseUrl + '/v1/facility/find?typeCode=' + typeId
    );
  }

  setStructureForTransition(transitionUuid: string, facilityCode: string) {
    return this.http.put<any>(
      this.baseUrl +
        `/v1/transition/${transitionUuid}/facility/${facilityCode}/facility-change`,
      null
    );
  }

  deleteStructureForTransition(transitionUuid: string) {
    return this.http.put<any>(
      this.baseUrl +
        `/v1/transition/${transitionUuid}/facility-remove`,
      null
    );
  }

  getWardInfo(code: string) {
    return this.http.get<any>(
      this.baseUrl + `/v1/ward/${code}`
    );
  }
}
